import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { nullCheck } from "../../../../utils/dataHelpers";
import CarrierOfferAction from "./ActionsComponents/CarrierOfferAction/CarrierOfferAction";
import LoadBookingAction from "./ActionsComponents/LoadBookingAction/LoadBookingAction";
import QuickActionsAction from "./ActionsComponents/QuickActionsAction/QuickActionsAction";
import ShotClockAction from "./ActionsComponents/ShotClockAction/ShotClockAction";
import EditCapacityAction from "./ActionsComponents/EditCapacityAction/EditCapacityAction";
import ExpireCapacityAction from "./ActionsComponents/ExpireCapacityAction/ExpireCapacityAction";
import EditCarrierContactAction from "./ActionsComponents/EditCarrierContactAction/EditCarrierContactAction";
import DeleteCarrierContactAction from "./ActionsComponents/DeleteCarrierContactAction/DeleteCarrierContactAction";
import UpdatePrimaryCarrierContactAction from "./ActionsComponents/UpdatePrimaryCarrierContactAction/UpdatePrimaryCarrierContactAction";
import PostLoadAction from "./ActionsComponents/PostLoadAction/PostLoadAction";

export default function ActionsCell({ row, column, actionCallback, updateData }) {
  const [availableToBook, setAvailableToBook] = useState(false);
  const rowItem = nullCheck(row, null, "original");
  const userIdMcld = nullCheck(column, null, "userIdMcld");
  const activeCarrier = nullCheck(column, null, "activeCarrier");
  const originPoint = nullCheck(column, null, "originPoint");
  const active = nullCheck(row, false, "original", "activeRow");
  const actions = column?.actions;
  let carrierId = "";

  if (column.carrierId) {
    carrierId = nullCheck(column, null, "carrierId");
  } else {
    carrierId = rowItem.carrierId;
  }

  const actionComponents = {
    "post-load": <PostLoadAction load={rowItem} active={active} rowId={row.index} updateData={updateData} />,
    "carrier-offer": <CarrierOfferAction load={rowItem} carrierId={carrierId} active={active} actionCallback={actionCallback} />,
    "shot-clock": <ShotClockAction load={rowItem} setAvailableToBook={setAvailableToBook} active={active} actionCallback={actionCallback} />,
    "load-booking": <LoadBookingAction availableToBook={availableToBook} load={rowItem} carrierId={carrierId} active={active} originPoint={originPoint} actionCallback={actionCallback} />,
    "quick-actions": <QuickActionsAction load={rowItem} active={active} actionCallback={actionCallback} />,
    "edit-capacity": <EditCapacityAction activeCarrier={activeCarrier} originPoint={originPoint} lane={rowItem} actionCallback={actionCallback} />,
    "expire-capacity": <ExpireCapacityAction userIdMcld={userIdMcld} originPoint={originPoint} lane={rowItem} actionCallback={actionCallback} />,
    "edit-carrier-contact": <EditCarrierContactAction activeCarrier={activeCarrier} contact={rowItem} actionCallback={actionCallback} />,
    "delete-carrier-contact": <DeleteCarrierContactAction originPoint={originPoint} activeCarrier={activeCarrier} contact={rowItem} actionCallback={actionCallback} contactUpdated={updateData} />,
    "update-primary-contact": <UpdatePrimaryCarrierContactAction originPoint={originPoint} activeCarrier={activeCarrier} contact={rowItem} contactUpdated={updateData} />
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", height: "20px" }}>
      {actions?.map((action, i) => (
        <Box
          key={i}
          sx={{ ...(i != 0 && { marginLeft: "4px" }) }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {actionComponents[action]}
        </Box>
      ))}
    </Box>
  );
}

ActionsCell.propTypes = {
  row: PropTypes.object,
  column: PropTypes.object,
  actionCallback: PropTypes.func,
  updateData: PropTypes.func
};